var _circle, _circle2, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncompleteRecords(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 25.556,
    cy: 25.142,
    r: 24.7533,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.1909,
    cy: 31.5073,
    r: 18.3882,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4722 29.3857C13.4487 29.3857 14.2403 30.1773 14.2403 31.1538C14.2403 32.1303 13.4487 32.9219 12.4722 32.9219C11.4957 32.9219 10.7041 32.1303 10.7041 31.1538C10.7041 30.1773 11.4957 29.3857 12.4722 29.3857Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4722 20.5449C13.4487 20.5449 14.2403 21.3365 14.2403 22.313C14.2403 23.2895 13.4487 24.0811 12.4722 24.0811C11.4957 24.0811 10.7041 23.2895 10.7041 22.313C10.7041 21.3365 11.4957 20.5449 12.4722 20.5449Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4722 11.705C13.4487 11.705 14.2403 12.4966 14.2403 13.4731C14.2403 14.4496 13.4487 15.2412 12.4722 15.2412C11.4957 15.2412 10.7041 14.4496 10.7041 13.4731C10.7041 12.4966 11.4957 11.705 12.4722 11.705Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3315 24.0811H19.4384C18.5205 24.0811 17.7764 23.3369 17.7764 22.419V22.2069C17.7764 21.289 18.5205 20.5449 19.4384 20.5449H37.3315C38.2494 20.5449 38.9935 21.289 38.9935 22.2069V22.419C38.9935 23.3369 38.2494 24.0811 37.3315 24.0811Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3315 32.9219H19.4384C18.5205 32.9219 17.7764 32.1778 17.7764 31.2599V31.0477C17.7764 30.1298 18.5205 29.3857 19.4384 29.3857H37.3315C38.2494 29.3857 38.9935 30.1298 38.9935 31.0477V31.2599C38.9935 32.1778 38.2494 32.9219 37.3315 32.9219Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncompleteRecords);
export default __webpack_public_path__ + "static/media/Incomplete Records.0b831cb4ad76a694ab51852ed26f88e6.svg";
export { ForwardRef as ReactComponent };